
define('text!templates/modules/questionnaire/questions/edit/question-edit-content.html',[],function () { return '<div class="panel-body question-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="question-edit-form"></div>\n    <div class="save-and-add-button"></div>\n</div>\n';});

